
import React from "react";
import Topsection from "./Topsection";
import Header from "./Header";
import Footer from "./Footer";
import FloatingButton from "./FloatingButton";

import { Helmet } from 'react-helmet';

const RefundPolicy = () => {

  return (
    <div>
      <Helmet>
            <title>Fortune Cloud Technologies | Refund Policy</title>
            <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
            <meta name="robots" content="index, follow" />
    </Helmet>
      <Topsection />
      <Header />
      <div className="courseslinear">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12 mb-4">

            <div className="col align-start-center flex-wrap m-3">
                <strong><h2 className="text-center text-dark myfont1 fw-bold">Refund Policy</h2></strong>
            </div>

              <div className="border p-4 p-md-5 rounded shadow-sm bg-white border border-3 d-flex">

                <div className="text-dark fs-bold myfont1 text-justify fs-5">
                  <h4 className="fw-bold">Refund of Payment Receive</h4>
                  <p>For any valid reason if your payment is not proceeded or service is not provided by our side then full money as you paid will refunded to you, further refund process will initiate after confirmation that service is not provided by us.</p>
                  

                  <h4 className="mt-4 fw-bold">Refund Request</h4>
                  <p>Refund request can be sent at admin@fortunecloudindia.com. Further refund request can be made within 10 days of online application made.</p>

                  <h4 className="mt-4 fw-bold">Refund Time Frame</h4>
                  <p>We will process your refund request within 10 to 15 business days from the date of receiving all the information required for processing refund like reason for refund, bank details for processing request, etc.</p>

                  <h4 className="mt-4 fw-bold">Cancellation of Application</h4>
                  <p>You cannot cancel the process once it is processed from our side.</p>

                  <h4 className="mt-4 fw-bold">Certification About Application</h4>
                  <p>If you have any query about any process, you can write us mail admin@fortunecloudindia.com. In case we need any additional clarification about your application our team will reach you by email or call.</p>
                  
                  <h4 className="mt-4 fw-bold">Force Majeure</h4>
                  <p>Fortune Cloud Technologies Private Limited shall not be considered in breach of its Satisfaction Guarantee policy or default under any terms of service, and shall not be liable to the Client for any cessation, interruption, or delay in the performance of its obligations by reason of earthquake, flood, fire, storm, lightning, drought,landslide, hurricane, cyclone, typhoon, tornado, natural disaster, act of God or the public enemy, epidemic, famine or plague, action of a court or public authority, change in law, explosion, war, terrorism, armed conflict, labour strike, lockout, boycott or similar event beyond our reasonable control, whether foreseen or unforeseen (each a "Force Majeure Event").</p>

                  <h4 className="mt-4 fw-bold">7-Day Refund Policy</h4>
                  <p>We offer a 100% refund within the first 7 days of enrollment — no questions asked. Your satisfaction is our priority.
                    No refunds will be issued after 7 days.</p>

                  {/* <h4>Changes to this privacy policy</h4>
                  <p>Fortune Cloud Technologies Private Limited have the discretion to update this privacy policy at any time. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.</p> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <FloatingButton />
    </div>
  );
};

export default RefundPolicy;
